import { Reveal } from "@/components/Reveal";
import { Wind, ShieldAlert, Thermometer, Wrench, ArrowUpRight } from "lucide-react";

const IMG_HVAC =
    "https://images.unsplash.com/photo-1542274368-443d694d79aa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwaHZhYyUyMG1ldGFsfGVufDB8fHx8MTc4NTUyODA5M3ww&ixlib=rb-4.1.0&q=85";
const IMG_FILTER =
    "https://images.unsplash.com/photo-1615309662243-70f6df917b59?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwaHZhYyUyMG1ldGFsfGVufDB8fHx8MTc4NTUyODA5M3ww&ixlib=rb-4.1.0&q=85";

const services = [
    {
        n: "01",
        icon: Wind,
        title: "Air Filtration Systems",
        desc: "HEPA & carbon filtration, HVAC intake protection and particulate control keeping accommodation and control rooms breathable.",
        img: IMG_FILTER,
        span: "lg:col-span-2",
    },
    {
        n: "02",
        icon: ShieldAlert,
        title: "Hazardous Gas Pressurization",
        desc: "Positive-pressure containment for Zone 1/2 areas — the critical barrier that keeps ignition sources and toxic gas apart.",
        img: IMG_HVAC,
        span: "lg:col-span-1",
    },
    {
        n: "03",
        icon: Thermometer,
        title: "Climate Control",
        desc: "Marine-grade chillers, AHUs and dehumidification tuned for salt-laden air and extreme offshore thermal loads.",
        img: null,
        span: "lg:col-span-1",
    },
    {
        n: "04",
        icon: Wrench,
        title: "Preventive Maintenance",
        desc: "Scheduled offshore call-outs, compliance inspections and emergency repair with certified rope-access and hot-work crews.",
        img: null,
        span: "lg:col-span-2",
    },
];

export default function Services() {
    return (
        <section id="services" data-testid="services-section" className="bg-abyss py-24 lg:py-32">
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
                <Reveal className="mb-14 flex flex-col md:flex-row md:items-end justify-between gap-6">
                    <div>
                        <span className="font-mono-tech text-xs uppercase tracking-[0.3em] text-safety">
                            / Capabilities
                        </span>
                        <h2 className="mt-4 font-heading font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.9]">
                            Four disciplines.<br />One hostile environment.
                        </h2>
                    </div>
                    <p className="max-w-sm text-steel leading-relaxed">
                        Every system we touch is rated for the deck, the derrick and the
                        blast zone — never for the office.
                    </p>
                </Reveal>

                <div className="grid grid-cols-1 lg:grid-cols-3 border-l border-t border-border">
                    {services.map((s, i) => (
                        <Reveal
                            key={s.n}
                            delay={i * 0.08}
                            className={`group relative border-r border-b border-border p-8 lg:p-10 min-h-[320px] flex flex-col justify-between overflow-hidden transition-colors hover:bg-surface ${s.span}`}
                        >
                            {s.img && (
                                <div className="absolute inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-500">
                                    <img src={s.img} alt="" className="h-full w-full object-cover" />
                                </div>
                            )}
                            <div className="relative z-10 flex items-start justify-between">
                                <s.icon className="h-8 w-8 text-safety" strokeWidth={1.5} />
                                <span className="font-mono-tech text-sm text-steel">{s.n}</span>
                            </div>
                            <div className="relative z-10">
                                <h3 className="font-heading font-bold text-2xl lg:text-3xl tracking-tight mb-3 flex items-center gap-2">
                                    {s.title}
                                    <ArrowUpRight className="h-5 w-5 text-safety opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                                </h3>
                                <p className="text-steel leading-relaxed max-w-md">{s.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
